import { render, staticRenderFns } from "./turaltpaket.vue?vue&type=template&id=764d496a&"
import script from "./turaltpaket.vue?vue&type=script&lang=js&"
export * from "./turaltpaket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports